import React from "react";
const ModalConfirmation = ({
    title,
    desc,
    handleClose,
    show,
}) => {
    return (
        <>
            {show && <div className="modal-backdrop show"></div>}
            <div
                className={show ? "modal fade show" : "modal fade"}
                role="dialog"
                style={{ display: show ? "block" : "none" }}
            >
                <div
                    className="modal-dialog modal-lg modal-dialog-centered"
                    role="document"
                >
                    <div className="modal-content border-top-gold">
                        <div className="text-end me-4 mt-3">
                            <button
                                onClick={handleClose}
                                type="button"
                                className="text-end btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div
                            className="modal-body my-1 text-center"
                        >
                            <h4 className="mb-4">{title}</h4>
                            <p className="mb-4">{desc}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ModalConfirmation;
